import { render, staticRenderFns } from "./AppHeaderBrand.vue?vue&type=template&id=5c0d7de6&scoped=true&"
import script from "./AppHeaderBrand.vue?vue&type=script&lang=js&"
export * from "./AppHeaderBrand.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderBrand.vue?vue&type=style&index=0&id=5c0d7de6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0d7de6",
  null
  
)

export default component.exports